<div class="container d-flex align-items-center justify-content-center min-vh-100">
  <div class="text-center error-page">
    <div *ngIf="statusCode" class="status-code mb-2">{{ statusCode }}</div>
    <h1 class="mb-3" [translate]="'error.title'">Došlo je do greške</h1>
    <p class="lead mb-4 muted" *ngIf="errorKey as k">{{ k | translate }}</p>

    <div class="d-flex justify-content-center error-actions">
      <a class="btn btn-primary" [routerLink]="['/']">
        <fa-icon [icon]="'home'"></fa-icon>
        <span class="ms-1">{{ 'error.action.home' | translate }}</span>
      </a>
      <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
        <fa-icon [icon]="'chevron-left'"></fa-icon>
        <span class="ms-1">{{ 'error.action.back' | translate }}</span>
      </button>
    </div>
  </div>
</div>
